import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./HomePageSkeleton.css"; // Custom styles
import Wrapper from "../../wrapper/Wrapper";

const HomePageSkeleton = () => {
  return (
    <div className="homepage-skeleton">
      {/* Top Info Bar */}
      {/* <div className="ske-top-bar">
        <Wrapper>
          <div className="ske-top-bar-container">
            <Skeleton width={300} height={14} />
            <div className="top-bar-right">
              <Skeleton width={180} height={14} />
              <Skeleton width={100} height={14} />
            </div>
          </div>
        </Wrapper>
      </div> */}

      {/* Navbar */}
      <div className="ske-navbar">
        <Wrapper>
          <div className="ske-nav-container">
            <div className="ske-logo">
              <Skeleton circle width={40} height={40} />
              <Skeleton width={160} height={20} />
            </div>
            <div className="ske-nav-links">
              {[...Array(4)].map((_, i) => (
                <Skeleton key={i} width={70} height={18} />
              ))}
              <Skeleton width={130} height={35} borderRadius={20} />
            </div>
          </div>
        </Wrapper>
      </div>

      {/* Hero Section */}
      <div className="ske-hero-section">
        <div className="ske-hero-left">
          <Skeleton width={140} height={18} />
          <Skeleton height={36} />
          <Skeleton height={200} />
          <Skeleton width={`80%`} height={18} />
          <Skeleton width={130} height={40} borderRadius={20} />
        </div>
        <div className="ske-hero-right">
          <Skeleton style={{ width: "100%" }} height={400} />
        </div>
      </div>
    </div>
  );
};

export default HomePageSkeleton;
